import { useSuspenseQuery } from '@apollo/client'
import { FetchGoalConfigsDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath, useCanForFeatures, useMe } from '@salescore/client-common'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Alert } from 'antd'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { GoalsSheet } from '../../../../../../../components/GoalsSheet.tsx'

//
// 目標入力のページ
//
const Page = (): ReactNode => {
  const navigate = useNavigate()
  const { organizationId, goalConfigId } = Route.useParams()
  // 大したレコード数にならない想定なので、全取得している
  const {
    data: { goalConfigs, userGroups },
  } = useSuspenseQuery(FetchGoalConfigsDocument, {
    variables: {
      organizationId: getOrganizationIdFromPath(),
    },
    fetchPolicy: 'cache-and-network',
  })
  const me = useMe()
  const { t } = useTranslation()
  const { canManageGoal } = useCanForFeatures()

  if (!canManageGoal) {
    return (
      <div>
        <Alert type="warning" message={t(`権限がありません`)} />
      </div>
    )
  }

  const goalConfig = goalConfigs.find((x) => x.id === goalConfigId)

  if (goalConfig === undefined) {
    return <div>{t(`目標が見つかりません`)}</div>
  }

  if (goalConfig.dashboardView === undefined) {
    return <div>{t(`この目標が紐づいていたダッシュボードが削除されました。`)}</div>
  }

  if (goalConfig.kpiViews.length === 0) {
    return (
      <div>
        {t(`このダッシュボードにはKPIが設定されていません。`)}
        <br />
        {t(`まずはKPIの設定を行なってください。`)}
      </div>
    )
  }

  return (
    <div>
      <GoalsSheet
        organizationId={organizationId}
        goalConfig={goalConfig}
        userGroups={userGroups}
        organizationSetting={me.organization.setting}
        onBack={() => {
          void navigate({ to: '/o/$organizationId/v2/settings/goal_configs', params: { organizationId } })
        }}
      />
    </div>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/goal_configs/$goalConfigId/')({
  component: Page,
})
